/** DOM を組み立てるための小さなヘルパー群 */

export type Attrs = Record<string, string | number | boolean | undefined>;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  children: (Node | string | null | undefined)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue;
    if (key === 'class') node.className = String(value);
    else if (key === 'text') node.textContent = String(value);
    else if (value === true) node.setAttribute(key, '');
    else node.setAttribute(key, String(value));
  }
  for (const child of children) {
    if (child === null || child === undefined) continue;
    node.append(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

export function clear(node: Element): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

export function show(node: HTMLElement, visible: boolean): void {
  node.hidden = !visible;
}

/** 0..1 のスライダー行を作る */
export function sliderRow(
  label: string,
  value: number,
  range: { min: number; max: number; step: number },
  onInput: (value: number) => void,
  format: (value: number) => string = (v) => v.toFixed(2),
): HTMLElement {
  const output = el('span', { class: 'slider-value', text: format(value) });
  const input = el('input', {
    type: 'range',
    min: range.min,
    max: range.max,
    step: range.step,
    value,
    class: 'slider',
  });
  input.addEventListener('input', () => {
    const next = Number(input.value);
    output.textContent = format(next);
    onInput(next);
  });
  return el('label', { class: 'slider-row' }, [
    el('span', { class: 'slider-label', text: label }),
    input,
    output,
  ]);
}

export function toggleRow(
  label: string,
  value: boolean,
  onChange: (value: boolean) => void,
): HTMLElement {
  const input = el('input', { type: 'checkbox', class: 'toggle' });
  input.checked = value;
  input.addEventListener('change', () => onChange(input.checked));
  return el('label', { class: 'slider-row' }, [
    el('span', { class: 'slider-label', text: label }),
    input,
  ]);
}

export function button(
  label: string,
  onClick: () => void,
  className = 'btn',
): HTMLButtonElement {
  const node = el('button', { class: className, type: 'button', text: label });
  node.addEventListener('click', (event) => {
    event.preventDefault();
    onClick();
  });
  return node;
}
